import { put, takeEvery, select } from "redux-saga/effects";
import {
  SagaRegistry,
  NMAxiosInst,
  requestHandler,
  getDepartments,
  getCurrentUser,
} from "@neumetric/blueprint-lib/store";
import { DateTimeUtil, Helper } from "@neumetric/blueprint-lib/utility";
import { centralActions } from "./slice";
import { parseRemediationStatsData } from "./parser/remediation";

const mapContent = (departments, types, classifications, statusList, _) => {
  const content = { ..._, more: "Info", key: _.id };
  content.updated_at = new (DateTimeUtil(content.updated_at).toString())();
  content.created_at = new (DateTimeUtil(content.created_at).toString())();
  content.creator = Helper.getUserObject(content.creator);
  content.updater = Helper.getUserObject(content.updater);
  if (Array.isArray(departments)) {
    const dept = departments.find((_) => _.id === content.department_name);
    if (dept) content.department_name = dept;
  }
  if (Array.isArray(types)) {
    const type = types.find((_) => _.id === content.doc_type);
    if (type) content.doc_type = type;
  }
  if (Array.isArray(statusList)) {
    const status = statusList.find((_) => _.id === content.status);
    if (status) content.status = status;
  }
  if (Array.isArray(classifications)) {
    const classif = classifications.find(
      (_) => _.id === content.classification
    );
    if (classif) content.classification = classif;
  }
  content.doc_linkname = `${content.doc_id}-${content.name}`;
  content.doc_link = `/D/${content.guid}`;
  content.doc_history = [];
  content.change_history = [];
  return content;
};

function* fetchDateRangeEnums() {
  yield requestHandler(function* () {
    // const res = yield NMAxiosInst.get(`/incidents/date_range_list`);
    let list = [
      { id: "last_7_days", label: "Last 7 Days" },
      { id: "last_week", label: "Last Week (Sun-Sat)" },
      { id: "last_30_days", label: "Last 30 Days" },
      { id: "last_month", label: "Previous Month" },
      { id: "last_90_days", label: "Last 90 Days" },
      { id: "last_year", label: "Previous Quarter" },
      { id: "last_365_days", label: "Last 365 Days" },
      { id: "previous_year", label: "Previous Year (Apr-Mar)" },
      { id: "over_all", label: "Entire History" },
    ];
    yield put(centralActions.setDateRangeEnums(list));
  }, "Failed to load Date Range list");
}
function* fetchCentralGuides() {
  yield requestHandler(function* () {
    let path = "active_guide_list";
    let res = yield NMAxiosInst.get("/guides/" + path);
    if (res) {
      res = res.guide_list ? res.guide_list : res;
      res = Array.isArray(res) ? res : [];
      res.sort(DateTimeUtil.sorterCB.bind(null, "updated_at"));
    }
    yield put(centralActions.setGuides(res));
  }, "Failed to Fetch Central Guides List");
}
function* fetchCentralGuide({ payload }) {
  yield requestHandler(function* () {
    let { id } = payload;
    let res = yield NMAxiosInst.get("/guides/show_guide?guide_id=" + id);
    const departments = yield select(getDepartments);
    if (res) {
      const guide_content = mapContent(departments, res);
      yield put(centralActions.setShowGuide({ guide: guide_content }));
    }
  }, "Failed to fetch Central Guide");
}
function* fetchRemediatorStats({ payload }) {
  yield requestHandler(function* () {
    const departments = yield select(getDepartments);
    const user = yield select(getCurrentUser);
    let { dateRange } = payload;
    let body = {
      date_range_type: dateRange || "last_365_days",
    };
    let res = yield NMAxiosInst.post("/tasks/arc_central_dashboard", body);
    yield put(
      centralActions.setRemediatorStats(
        parseRemediationStatsData(res, user, departments)
      )
    );
  }, "Failed to fetch Remediator Stats");
}
function* fetchCurrentOrgLogo() {
  yield requestHandler(function* () {
    const user = yield select(getCurrentUser);
    const logoUrl = user.org.logo_url;
    const blob = yield NMAxiosInst.postExport("/consoles/download_s3_file", {
      url: logoUrl,
    });
    yield put(centralActions.setCurrentOrgLogo(blob));
  }, "Failed to fetch Current Org Logo");
}
function* fetchMitigatorDashboardData() {
  yield requestHandler(function* () {
    const res = yield NMAxiosInst.get("/risks/org_risks_dashboard");
    yield put(centralActions.setMitigatorDashboardData(res));
  }, "Failed to fetch stats data");
}

SagaRegistry.register(function* docSaga() {
  yield takeEvery("central/fetchDateRangeEnums", fetchDateRangeEnums);
  yield takeEvery("central/fetchCentralGuides", fetchCentralGuides);
  yield takeEvery("central/fetchCentralGuide", fetchCentralGuide);
  yield takeEvery("central/fetchRemediatorStats", fetchRemediatorStats);
  yield takeEvery("central/fetchCurrentOrgLogo", fetchCurrentOrgLogo);
  yield takeEvery(
    "central/fetchMitigatorDashboardData",
    fetchMitigatorDashboardData
  );
});
